module.exports = __webpack_public_path__ + "static/devteam_04-4c7b84b06ad9df78b0336c91ce7cf4a0.jpg";